//
//
//
//
//
//

export default {
  name: "RichTextModule",
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    text() {
      return this.info.content?.content;
    }
  },
  methods: {
    linksBehavior() {
      const links = this.$el.querySelectorAll?.('.rich-text-editor a');
      if(links && links.length) {
        links.forEach(item => {
          item.onclick = (e) => {
            e.preventDefault();
            const linkUrl = e.target?.href ? e.target.getAttribute('href') : e.target.parentNode.getAttribute('href');
            if(!linkUrl) {
              return;
            }
            if(linkUrl.search(/http/i) === 0) {
              window.open(linkUrl);
            } else {
              this.$router.push(linkUrl);
            }
          }
        })
      }
    },
    reloadContentScripts() {
      const scripts = this.$el.querySelectorAll?.('script');
      if (scripts?.length) {
        scripts.forEach(item => {
          const script = document.createElement('script');
          [...item.attributes].forEach( attr => { script.setAttribute(attr.nodeName, attr.nodeValue) })
          item.parentNode.replaceChild(script, item);
        });
      }
    }
  },
  mounted() {
    this.linksBehavior();
    this.reloadContentScripts();
  }
}
